module.exports = __webpack_public_path__ + "static/media/LSK.f1a8a200.svg";